import type { UscLabelType } from "../utils/labels";
import { UscCheckoutType } from "../../shared-logic/types/UscCommonTypes";
import { useUscSelector } from "../redux/store";

type ExtrasReserveBuyLabelsType = {
    // General
    extrasTitle: UscLabelType;

    // Customer support
    extrasSupportQuestion: UscLabelType;
    extrasSupportDescriptionQuestion: UscLabelType;
    extrasSupportContact: UscLabelType;
    extrasSupportPhoneNr: UscLabelType;
    extrasSupportPhoneNrLabel: UscLabelType;
    extrasSupportPhoneNrDescription: UscLabelType;

    // Checkout steps
    extrasCheckoutStepsTitle: UscLabelType;
    extrasCheckoutStepsDescription: UscLabelType;
    extrasCheckoutStepsItems: UscLabelType;
};

const reserveLabels: ExtrasReserveBuyLabelsType = {
    // General
    extrasTitle: "uscExtrasReserveTitle",

    // Customer support
    extrasSupportQuestion: "uscExtrasReserveSupportQuestion",
    extrasSupportDescriptionQuestion: "uscExtrasReserveSupportQuestionDescription",
    extrasSupportContact: "uscExtrasReserveSupportContact",
    extrasSupportPhoneNr: "uscExtrasReserveSupportPhoneNr",
    extrasSupportPhoneNrLabel: "uscExtrasReserveSupportPhoneNrLabel",
    extrasSupportPhoneNrDescription: "uscExtrasReserveSupportPhoneNrDescription",

    // Checkout steps
    extrasCheckoutStepsTitle: "uscExtrasReserveStepsTitle",
    extrasCheckoutStepsDescription: "uscExtrasReserveStepsDescription",
    extrasCheckoutStepsItems: "uscExtrasReserveSteps",
};

const buyLabels: ExtrasReserveBuyLabelsType = {
    // General
    extrasTitle: "uscExtrasBuyTitle",

    // Customer support
    extrasSupportQuestion: "uscExtrasBuySupportQuestion",
    extrasSupportDescriptionQuestion: "uscExtrasBuySupportQuestionDescription",
    extrasSupportContact: "uscExtrasBuySupportContact",
    extrasSupportPhoneNr: "uscExtrasBuySupportPhoneNr",
    extrasSupportPhoneNrLabel: "uscExtrasBuySupportPhoneNrLabel",
    extrasSupportPhoneNrDescription: "uscExtrasBuySupportPhoneNrDescription",

    // Checkout steps
    extrasCheckoutStepsTitle: "uscExtrasBuyStepsTitle",
    extrasCheckoutStepsDescription: "uscExtrasBuyStepsDescription",
    extrasCheckoutStepsItems: "uscExtrasBuySteps",
};

/**
 * Returns buy or reserve specific labels used on the extras step
 */
const useExtrasBuyOrReserveLabels = (): ExtrasReserveBuyLabelsType => {
    const checkoutType = useUscSelector((state) => state.basket.checkoutType);

    return checkoutType === UscCheckoutType.Reserve ? reserveLabels : buyLabels;
};

export default useExtrasBuyOrReserveLabels;
